import React from "react";
import { Link } from "react-router-dom";
import LayoutOne from "../../layouts/LayoutOne";
import { useLanguage } from "../../context/LanguageContext";

const SuccessfulFormSubmission = () => {
  const { t } = useLanguage();

  return (
    <LayoutOne>
      <main className="thank-you-page">
        <section className="thank-you-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto">
                <div className="thank-you-content text-center">
                  <div className="thank-you-icon">
                    <i className="fas fa-check"></i>
                  </div>
                  <h1>{t("thankYou.title")}</h1>
                  <p>{t("thankYou.description")}</p>
                  <div className="header-btn">
                    <Link to="/" className="btn">
                      {t("thankYou.button")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </LayoutOne>
  );
};

export default SuccessfulFormSubmission;
